module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 11
// module chunks = 0